import { WatcherrApiError, watcherrErrorTranslationKeys } from '@ixicare/resources';
import { t } from '~i18n';

export const humaniseErrors = (error: Error): { title: string; description?: string; img?: string } => {
  if (error instanceof WatcherrApiError) {
    error.response
      .text()
      .then((body) => {
        console.warn('Showing error to user', error, body);
      })
      .catch(() => {
        console.warn('Showing error to user', error);
      });
  } else {
    console.warn('Showing error to user', error);
  }

  const { title, description, translatable } = watcherrErrorTranslationKeys(error);
  return {
    title: translatable ? t(title) : title,
    description: description ? (translatable ? t(description) : description) : undefined,
  };
};

export const humaniseErrorToMessage = (error: Error) => {
  const { title, description } = humaniseErrors(error);
  return `${title}\n ${description}`;
};

export const getFieldError = (key: string, error?: Error) => {
  if (!(error instanceof WatcherrApiError) || !(error as any).body) {
    return;
  }
  const errorBody = (error as any).body;
  const fieldErrors = errorBody.fieldErrors && key in errorBody.fieldErrors ? errorBody.fieldErrors[key] : undefined;
  return fieldErrors ? fieldErrors.join(', ') : undefined;
};
